import * as React from "react";
import PropTypes from "prop-types";
import { nanoid } from "nanoid";
const YouTubeIFrame = ({ title = "", id }) => {
  if (!title) {
    title = nanoid();
  }
  return (
    <div className="content iframe-container">
      <iframe
        className="iframe-responsive"
        title={title}
        loading="lazy"
        src={`https://www.youtube.com/embed/${id}?feature=oembed`}
        allowFullScreen={true}
      />
    </div>
  );
};

YouTubeIFrame.propTypes = {
  url: PropTypes.string,
};

export default YouTubeIFrame;
